<table mat-table [dataSource]="activeDataSource" matSort>
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>PO Name</th>
    <td mat-cell *matCellDef="let po">
      <mat-icon matTooltip="PO Paused" class="mr-1 text-red-501" *ngIf="po.pausedTimestamp !== null">
        pause
      </mat-icon>
      {{ po.name }}
    </td>
  </ng-container>

  <ng-container matColumnDef="mineName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Mine</th>
    <td mat-cell *matCellDef="let po">
      {{ po.mineName }}
    </td>
  </ng-container>

  <ng-container matColumnDef="meshType">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Mesh Type</th>
    <td mat-cell *matCellDef="let po">
      {{ po.meshType }}
    </td>
  </ng-container>

  <ng-container matColumnDef="costPerTon">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Cost Per Ton</th>
    <td mat-cell *matCellDef="let po">
      {{ po.costPerTon | currencyInPennies }}
    </td>
  </ng-container>

  <ng-container matColumnDef="orderedToday">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <div class="flex flex-col items-start">
        <div>Today's Usage</div>
        <div>(Across All Fracs)</div>
      </div>
    </th>
    <td mat-cell *matCellDef="let po">
      <div class="flex flex-col pr-3">
        <mat-progress-bar
          [color]="(po.orderedToday / po.maximumDailyAllocation) * 100 > 100 ? 'warn' : 'primary'"
          mode="determinate"
          [value]="(po.orderedToday / po.maximumDailyAllocation) * 100"
          class="mb-1"
        ></mat-progress-bar>
        <div>
          {{ po.orderedToday || 0 | poLoaderPoundTonConversion | approxBigNumber }} of
          {{ po.maximumDailyAllocation || 0 | poLoaderPoundTonConversion | approxBigNumber | poLoaderPoundTonUnit }}
        </div>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="totalAllocationUsed">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <div class="flex flex-col items-start">
        <div>Total Usage</div>
        <div>(Across All Fracs)</div>
      </div>
    </th>
    <td mat-cell *matCellDef="let po">
      <div class="flex flex-col pr-3">
        <mat-progress-bar
          [color]="(po.totalAllocationUsed / po.allocation) * 100 > 100 ? 'warn' : 'primary'"
          mode="determinate"
          [value]="(po.totalAllocationUsed / po.allocation) * 100"
          class="mb-1"
        ></mat-progress-bar>
        <div>
          {{ po.totalAllocationUsed || 0 | poLoaderPoundTonConversion | approxBigNumber }} of
          {{ po.allocation || 0 | poLoaderPoundTonConversion | approxBigNumber | poLoaderPoundTonUnit }}
        </div>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="createdTimestamp">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
    <td mat-cell *matCellDef="let po">
      {{ po.createdTimestamp | date: 'short' | dashIfNothing }}
    </td>
  </ng-container>

  <ng-container matColumnDef="expirationTime">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Expiration Date</th>
    <td mat-cell *matCellDef="let po">
      {{ po.expirationTime | date: 'shortDate' | dashIfNothing }}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let po; columns: displayedColumns"
    [routerLink]="['/', 'lmo', 'purchase_order', 'detail', po.id]"
    class="cursor-pointer"
  ></tr>
</table>
